import { PIP_CORNER_OPTIONS, PipCorner } from './constants';
import { classnames } from '@/libs/utils';

/**
 * PiP-corner picker: a 2x2 grid where the selected corner is filled.
 * Persisted via asset_metadata.pip_position (see PIP_CORNER_TO_POSITION in ./constants).
 */
export default function PipCornerSelector({
  value,
  onChange,
  disabled = false
}: {
  value: PipCorner;
  onChange: (value: PipCorner) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="text-sm font-medium">PiP corner</div>
      <div
        className={classnames('grid grid-cols-2 gap-1.5 rounded-lg bg-slate-100 p-1.5', disabled ? 'opacity-50' : '')}
        role="radiogroup"
        aria-label="PiP corner"
      >
        {PIP_CORNER_OPTIONS.map(corner => (
          <button
            key={corner}
            type="button"
            role="radio"
            aria-checked={value === corner}
            aria-label={corner}
            disabled={disabled}
            onClick={() => onChange(corner)}
            className={classnames(
              'h-[18px] w-6 rounded-sm transition-colors disabled:cursor-not-allowed',
              value === corner ? 'border-slate-900 bg-slate-900' : 'border-slate-300 bg-white hover:border-slate-400'
            )}
          />
        ))}
      </div>
    </div>
  );
}
